import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[decimalOnly]'
})
export class DecimalInputDirective {

  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g); // 2 decimal places
  private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const current = (event.target as HTMLInputElement).value;
    const next = current.concat(event.key);

    if (!String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}